export const formatLargeNumber = (
  num: number,
): { result: string; type: 'm' | 'k' | 'normal' } => {
  if (num >= 1000000) {
    const result = (num / 1000000).toFixed(1);
    return {
      result: `${parseFloat(result).toLocaleString()}`,
      type: 'm',
    };
  } else if (num >= 1000) {
    const result = (num / 1000).toFixed(1);
    return {
      result: `${parseFloat(result).toLocaleString()}`,
      type: 'k',
    };
  } else {
    return {
      result: num.toString(),
      type: 'normal',
    };
  }
};
